const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const ANCHOR_TOKEN_PREFIX = '__RICH_TEXT_ANCHOR_';

const extractAnchors = (value) => {
  const anchors = [];

  const text = String(value).replace(/<a\b[^>]*>[\s\S]*?<\/a>/gi, (match) => {
    const token = `${ANCHOR_TOKEN_PREFIX}${anchors.length}__`;
    anchors.push(match);
    return token;
  });

  return { text, anchors };
};

const restoreAnchors = (value, anchors) =>
  anchors.reduce(
    (acc, anchor, index) =>
      acc.replace(
        new RegExp(`${ANCHOR_TOKEN_PREFIX}${index}__`, 'g'),
        () => anchor
      ),
    value
  );

const applyBoldMarkers = (value) =>
  value.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

const formatInlineMarkdown = (value) => {
  const { text, anchors } = extractAnchors(value);

  return restoreAnchors(
    applyBoldMarkers(escapeHtml(text)).replace(/\n/g, '<br />'),
    anchors
  );
};

export const formatMarkdownRichText = (value = '') => {
  const normalized = String(value).replace(/\r\n/g, '\n');
  if (!normalized.trim()) return '';

  return normalized
    .split(/\n{2,}/)
    .map((paragraph) => {
      const trimmed = paragraph.trim();
      if (!trimmed) return '';

      const lines = trimmed.split('\n').map((line) => line.trim());
      const isList = lines.every((line) => /^[-*]\s+/.test(line));

      if (isList) {
        const items = lines
          .map((line) => line.replace(/^[-*]\s+/, '').trim())
          .map((item) => `<li>${formatInlineMarkdown(item)}</li>`)
          .join('');

        return `<ul>${items}</ul>`;
      }

      return `<p>${formatInlineMarkdown(trimmed)}</p>`;
    })
    .filter(Boolean)
    .join('');
};
